import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUserModules } from ".";

const ProtectedRoute = ({
  component: Component,
  requiredModule,
  fallbackRoute = "/overview",
}) => {
  const { isModuleAccessible, isLoading } = useUserModules();
  const location = useLocation();

  // Function to check if the current path matches the required module
  const isModuleRoute = () => {
    // Convert current path to lowercase for case-insensitive matching
    const currentPath = location.pathname.toLowerCase();

    // Check if the path starts with the module name
    // This allows any route that begins with the module name
    return currentPath.includes(`/${requiredModule.toLowerCase()}`);
  };

  // If still loading modules, don't redirect yet - render a loading state or the component
  if (isLoading) {
    return <Component />;
  }

  // Check if the required module is accessible
  if (!isModuleAccessible(requiredModule) && isModuleRoute()) {
    return (
      <Navigate
        to={fallbackRoute}
        state={{
          from: location,
          moduleError: `You do not have access to the ${requiredModule} module`,
        }}
        replace
      />
    );
  }

  // If module is accessible or not a module route, render the component
  return <Component />;
};

export default ProtectedRoute;
